<template>
  <v-container class="rn-page" max-width="800">
    <div class="rn-header">
      <span class="rn-eyebrow">27PUB</span>
      <h1 class="rn-title">Release Notes</h1>
      <p class="rn-sub">What's new in Poker Management</p>
    </div>

    <v-card class="rn-card" elevation="1">
      <v-table class="rn-table">
        <thead>
          <tr>
            <th class="rn-th rn-th--version">Version</th>
            <th class="rn-th">Updates</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in releases" :key="entry.version" class="rn-row">
            <td class="rn-td rn-td--version">
              <span class="rn-version-badge">{{ entry.version }}</span>
            </td>
            <td class="rn-td">{{ entry.notes }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const releases = [
{ version: '0.61', notes: '10/1/2026 — fixed starting chip stack not saving, fixed timer sounds on iPads (iPad silent mode must be off)' },
{ version: '0.6', notes: '6/26/2026 — fixed editing of tournaments' },
{ version: '0.5', notes: '5/7/2026 — add groups for reporting, graphing on mobile, improved session entry, improved tournament timer' },
  { version: '0.41', notes: '4/15/2026 — Updated look and feel, alias editing, fixed length of tournament integration, used ambient sound setting for iPad and iPhone' },
 { version: '0.40',  notes: '2/25/2026 — Tournament timer, added results of tournament timer to linked players sessions' },
  { version: '0.30',  notes: '11/26/2025 — Added forgot password functionality' },
  { version: '0.20',  notes: '1/14/2025 — Fixed date default, added delete for check in' },
  { version: '0.10',  notes: 'Initial Beta Release' },
];
</script>

<style scoped>
.rn-page {
  padding-top: 48px;
  padding-bottom: 64px;
  font-family: 'DM Sans', sans-serif;
}

.rn-header {
  text-align: center;
  margin-bottom: 32px;
}

.rn-eyebrow {
  display: inline-block;
  font-family: 'DM Mono', monospace;
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #2D6A4F;
  background: #EAF4EE;
  padding: 3px 10px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.rn-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 2rem;
  font-weight: 700;
  color: #1A1A2E;
  margin: 8px 0 6px;
}

.rn-sub {
  font-size: 0.95rem;
  color: #6B7280;
}

.rn-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.rn-table {
  width: 100%;
}

.rn-th {
  font-family: 'DM Mono', monospace !important;
  font-size: 0.7rem !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.08em !important;
  color: #6B7280 !important;
  background: #F9FAFB;
  padding: 12px 16px !important;
  border-bottom: 1px solid #E5E7EB !important;
}

.rn-th--version {
  width: 110px;
}

.rn-row:hover td {
  background: #F9FAFB;
}

.rn-td {
  padding: 12px 16px !important;
  font-size: 0.9rem;
  color: #374151;
  border-bottom: 1px solid #F3F4F6 !important;
  vertical-align: middle;
}

.rn-td--version {
  width: 110px;
}

.rn-version-badge {
  display: inline-block;
  font-family: 'DM Mono', monospace;
  font-size: 0.8rem;
  font-weight: 500;
  color: #2D6A4F;
  background: #EAF4EE;
  padding: 2px 8px;
  border-radius: 4px;
}
</style>
